export default __webpack_public_path__ + "static/media/curriculum-virtual-patients-icon.4cedcf39.svg";